export default __webpack_public_path__ + "static/media/1944.7b0b202a.png";